import React, { useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import PaginationTable from "components/PaginationTable";
import { getCardDetails } from "redux/actions/usersActions";
import { sendEmailAction } from "redux/actions/cardActions";
import { showMessage } from "components/Modal";
import { LoadingButton } from "@mui/lab";
import { GET_VIRTUAL_CARDS } from "services/API/apiPaths";
import EmailIcon from "@mui/icons-material/Email";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// --------------------------------------------------------------------------------
const VirtualCards = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const paginationTableRef = useRef();

  const [loadingCard, setLoadingCard] = useState({});
  const [showConfirm, setShowConfirm] = useState(false);

  const handleResendEmail = (cardId) => {
    setLoadingCard((prevState) => ({
      ...prevState,
      [cardId]: true,
    }));

    dispatch(
      sendEmailAction({
        cardId,
        onSuccess: () => {
          setShowConfirm(false);
          showMessage({
            status: "success",
            description: "Email sent successfully",
          });
          setLoadingCard((prevState) => ({
            ...prevState,
            [cardId]: false,
          }));
        },
        onFailure: () => {
          showMessage({
            status: "error",
            description: "Failed to send email",
          });
          setLoadingCard((prevState) => ({
            ...prevState,
            [cardId]: false,
          }));
        },
      })
    );
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "full_name",
        header: "Full Name",
        mergedKeys: ["first_name", "last_name"],
      },
      {
        accessorKey: "email",
        header: "Email",
        size: 200,
      },
      {
        accessorKey: "card_number",
        header: "Card Number",
      },
      {
        accessorKey: "brand",
        header: "Brand",
        size: 100,
      },
      {
        accessorKey: "status",
        header: "Status",
        size: 100,
      },
      {
        accessorKey: "created_time",
        header: "Created Time",
      },
      {
        accessorKey: "updated_time",
        header: "Last Update",
      },
      {
        accessorKey: "operation",
        header: "Operation",
        size: 280,
        Cell: ({ row }) => (
          <div style={{ display: "flex", gap: "8px" }}>
            <LoadingButton
              startIcon={<EmailIcon />}
              onClick={() => handleResendEmail(row.original.card_id)}
              loading={loadingCard[row.original.card_id]}
              variant="contained"
              color="primary"
              disabled={row.original.agent?.is_premium === 0}
            >
              Resend Email
            </LoadingButton>
            <LoadingButton
              endIcon={<ArrowForwardIcon />}
              onClick={() => navigate(`/cards/${row.original.card_id}`)}
            >
              Card Detail
            </LoadingButton>
          </div>
        ),
      },
    ],
    [loadingCard]
  );

  return (
    <PaginationTable
      ref={paginationTableRef}
      apiEndpoint={GET_VIRTUAL_CARDS}
      title="Virtual Cards"
      columns={columns}
    />
  );
};

export default VirtualCards;
